import Quill, { Delta } from 'quill';
import Clipboard from 'quill/modules/clipboard';

class CustomClipboard extends Clipboard {
  onPaste(range, _ref3) {
    if (this.quill.options.noPaste) {
      // 禁用粘贴
      return;
    } else if (this.quill.options.normalPaste) {
      // 使用默认的粘贴逻辑
      super.onPaste(range, _ref3);
    } else {
      // 富文本粘贴，转换为纯文本格式
      let { text } = _ref3;
      const pastedDelta = new Delta().insert(text);
      const delta = new Delta().retain(range.index).delete(range.length).concat(pastedDelta);
      this.quill.updateContents(delta, Quill.sources.USER);
      this.quill.setSelection(delta.length() - range.length, Quill.sources.SILENT);
      this.quill.scrollSelectionIntoView();
    }
  }
  onCopy(range, isCut) {
    if (this.quill.options.noCopy) {
      // 禁用复制/剪切
      return { html: '', text: '' };
    } else {
      // 默认复制/剪切
      return super.onCopy(range, isCut);
    }
  }
}
Quill.register('modules/clipboard', CustomClipboard, true);
